import {Component, Input, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {Observable} from 'rxjs';
import {DimensionComponentObject, DimensionComponentObjects} from '../../../../../../shared/classes/dimension-component-object';
import {ReportTableRowParametersDimensionsStore} from './report-table-row-parameters-dimensions.store';
import {Serializer} from '../../../../../../shared/interfaces/serializer';
import {DataSetConditionalDimension, DataSetDimension, GeneralDimension} from '../../../../../../shared/interfaces/dimensions';
import {map} from 'rxjs/operators';

@Component({
  selector: 'app-report-table-row-parameters-dimensions',
  templateUrl: './report-table-row-parameters-dimensions.component.html',
  styleUrls: ['./report-table-row-parameters-dimensions.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ReportTableRowParametersDimensionsStore]
})
export class ReportTableRowParametersDimensionsComponent implements OnInit, OnDestroy {
  @Input('parameter') public set parameter(dimensions: Array<string> | null | undefined) {
    if (dimensions) {
      this._reportCardDimensionParametersStore.init(dimensions)
    }
  };

  public readonly dimensions$: Observable<DimensionComponentObjects> = this._reportCardDimensionParametersStore.dimensions$;

  public readonly dimension$: Observable<Serializer<GeneralDimension | DataSetDimension | DataSetConditionalDimension> | undefined> = this._reportCardDimensionParametersStore.dimension$
    .pipe(map((dimension: DimensionComponentObject): Serializer<GeneralDimension | DataSetDimension | DataSetConditionalDimension> | undefined => dimension?.payload as Serializer<GeneralDimension | DataSetDimension | DataSetConditionalDimension> | undefined));

  public readonly numberOfDimensions$: Observable<number> = this._reportCardDimensionParametersStore.numberOfDimensions$;
  public readonly enable$: Observable<boolean> = this._reportCardDimensionParametersStore.enable$;

  constructor(
    private readonly _reportCardDimensionParametersStore: ReportTableRowParametersDimensionsStore
  ) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {}

}
